export * from './documentdetail.component';
